import { css } from '@emotion/core';

/**
 * @function getWordBreak
 * @param {string} offset
 * @returns {string}
 * @description Since IE and Firefox don't support `word-break: break-word;`
 *  we can use that alone. This function will return styling that will work
 *  in all browsers. `word-wrap` is the legacy version of `overflow-wrap`, which
 *  is required for IE 11, Firefox supports `overflow-wrap`.
 */
const getWordBreak = (offset = '0px') => css`
  overflow-wrap: break-word;
  width: calc(100% - ${offset});
  word-break: break-word;
  word-wrap: break-word;
`;

export { getWordBreak };
